import Mentor from './component';

export default {
  path: 'mentor',
  component: Mentor,
};



// WEBPACK FOOTER //
// ./containers/Group/Homework/Mentor/routes.js